import { render, staticRenderFns } from "./OptimizationList.vue?vue&type=template&id=8c6127a0&scoped=true"
import script from "./OptimizationList.vue?vue&type=script&lang=js"
export * from "./OptimizationList.vue?vue&type=script&lang=js"
import style0 from "./OptimizationList.vue?vue&type=style&index=0&id=8c6127a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6127a0",
  null
  
)

export default component.exports